import { useRef } from 'react'
import cx from 'classnames'
import Styles from './ViewAsMenu.module.scss'
import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import { InstagramBrand } from 'blaze-ui/icons/24'
import { FacebookBrand } from 'blaze-ui/icons/35'
import { TwitterBrand } from 'blaze-ui/icons/20'
import { LinkedInBrand } from 'blaze-ui/icons/32'
import { Google, TikTokBrand, YouTubeBrand } from 'blaze-ui/icons'
import { useButton } from '@react-aria/button'
import { getCrossPostGroupForChannel } from '../utils'
import { ChannelType } from 'components/CampaignCreationModal/Types'
import { DesignChannel } from 'components/NewFileModal/Types'
import { GenerationType } from 'components/BlazeCommandLine/api/createDocGenerationRequest'

interface ViewAsMenuProps {
  activePlatform?: ExternalIntegrationEnum
  onSelectPlatform: (platform: ExternalIntegrationEnum) => void
  fileChannel: ChannelType | DesignChannel | GenerationType
  redesign?: boolean
}

const providerIcon: Partial<Record<ExternalIntegrationEnum, JSX.Element>> = {
  instagram: <InstagramBrand size={20} />,
  linkedin: <LinkedInBrand size={20} />,
  x: <TwitterBrand />,
  facebook: <FacebookBrand size={20} />,
  tiktok: <TikTokBrand size={20} />,
  youtube: <YouTubeBrand size={20} />,
  google_business_profile: <Google size={20} />,
}

const ViewAsButton = ({
  platform,
  onSelectPlatform,
  isActive,
  redesign,
}: {
  platform: ExternalIntegrationEnum
  onSelectPlatform: (platform: ExternalIntegrationEnum) => void
  isActive: boolean
  redesign?: boolean
}) => {
  const ref = useRef<HTMLDivElement>(null)
  const { buttonProps } = useButton({ onPress: () => onSelectPlatform(platform) }, ref)

  return (
    <div
      {...buttonProps}
      ref={ref}
      data-testid={`${platform}-platform`}
      className={cx(Styles.platformButton, { [Styles.active]: isActive, [Styles.redesignButton]: redesign })}
    >
      {providerIcon[platform]}
    </div>
  )
}

export const ViewAsMenu: React.FC<ViewAsMenuProps> = ({ activePlatform, onSelectPlatform, fileChannel, redesign }) => {
  const crossPostGroup = getCrossPostGroupForChannel(fileChannel)

  return (
    <div className={cx(Styles.root, { [Styles.redesign]: redesign })}>
      <div className={Styles.title}>View as</div>
      <div className={Styles.buttons}>
        {crossPostGroup.map((platform) => {
          return (
            <ViewAsButton
              key={platform}
              platform={platform}
              onSelectPlatform={onSelectPlatform}
              isActive={activePlatform === platform}
              redesign={redesign}
            />
          )
        })}
      </div>
    </div>
  )
}
